import { styled } from "styled-components";

export const ContractProductsRenewalReviewContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const ContractProductsRenewalReviewInfoTitle = styled.span`
  font-weight: 600;
`;

export const ContractProductsRenewalReviewWrapper = styled.div`
  max-height: 487px;
  overflow: auto;
`;
